import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import Landing from './pages/Landing';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Verify from './pages/Verify';
import Disclaimer from './pages/Disclaimer';
import PinSetup from './pages/PinSetup';
import PinLogin from './pages/PinLogin';
import Forgot from './pages/Forgot';
import PREP from './pages/PREP';
import MT from './pages/MT';

function App() {
  const [screen, setScreen] = useState('landing');
  const [portal, setPortal] = useState('prep');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        if (!u.emailVerified) {
          setScreen('verify');
        } else {
          const snap = await getDoc(doc(db, 'users', u.uid));
          if (!snap.exists() || !snap.data().pin) {
            setScreen('disclaimer');
          } else {
            setScreen('pin-login');
          }
        }
      } else {
        setScreen('landing');
      }
    });
    return () => unsub();
  }, []);

  const handleSwitch = (s, data) => {
    if (s === 'verify') setEmail(data);
    setScreen(s);
  };

  const handlePortal = (p) => {
    setPortal(p);
    setScreen('signup');
  };

  const handleLogout = () => {
    auth.signOut();
    setScreen('landing');
  };

  const handlePinSuccess = () => {
    if (portal === 'prep') setScreen('prep');
    else setScreen('mt');
  };

  const handleDisclaimerDone = () => {
    setScreen('pin-setup');
  };

  if (screen === 'landing') return <Landing onPortal={handlePortal} onLogin={() => setScreen('login')} />;
  if (screen === 'signup') return <Signup onSwitch={handleSwitch} />;
  if (screen === 'login') return <Login onSwitch={handleSwitch} />;
  if (screen === 'verify') return <Verify email={email} onVerified={() => setScreen('disclaimer')} />;
  if (screen === 'disclaimer') return <Disclaimer portal={portal} onAccept={handleDisclaimerDone} />;
  if (screen === 'pin-setup') return <PinSetup onDone={() => handlePinSuccess()} />;
  if (screen === 'pin-login') return <PinLogin onSuccess={() => handlePinSuccess()} />;
  if (screen === 'forgot') return <Forgot onSwitch={handleSwitch} />;
  if (screen === 'prep') return <PREP onLogout={handleLogout} onSwitch={setScreen} portal={portal} />;
  if (screen === 'mt') return <MT onLogout={handleLogout} onSwitch={setScreen} />;

  return null;
}

export default App;